// components/SimplePageHeader.js
import React from "react";
import {
  AppBar,
  Toolbar,
  useMediaQuery,
  Box,
  useTheme,
  IconButton,
} from "@mui/material";
import Logo from "./Logo";
import LogoSmall from "./LogoSmall";
import PageTitle from "./PageTitle";
import Hamburger from "hamburger-react";
import MenuBar from "./MenuBar";
import { useMenu } from "../../Context/MenuVisibility"; // Import the useMenu hook
import NotificationCenter from "../NotificationCenter";

function SimplePageHeader({
  iconName,
  titleString,
  showAddButton = true,
  onSearchChange,
  placeholderText = "Search...",
  pageType,
  showDownloadButton,
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery("(max-width:850px)");
  const jimmyBotLogo = `${process.env.PUBLIC_URL}/jimmybotlogo.png`;
  const { menuVisible, toggleMenu } = useMenu(); // Use the global menu context

  return (
    <>
      <AppBar
        position="sticky"
        style={{
          backgroundColor: theme.palette.primary.main,
          height: isSmallScreen ? "60px" : "80px",
          marginBottom: "0px",
        }}
      >
        <Toolbar
          style={{
            position: "relative",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "100%",
          }}
        >
          {/* Left Side: Logo */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: "auto",
            }}
          >
            {isSmallScreen ? <LogoSmall /> : <Logo />}
          </div>

          {/* Center: Title with Logo */}
          <Box
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              alignItems: "center",
              pointerEvents: "none",
            }}
          >
            <img
              src={jimmyBotLogo}
              alt="JimmyBot Logo"
              style={{
                height: isSmallScreen ? "50px" : "70px",
                marginRight: "8px",
              }}
            />
          </Box>

          {/* Right Side: Menu, search bar, and dark mode toggle */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "auto",
            }}
          >
             <NotificationCenter />
            <IconButton onClick={toggleMenu} style={{ color: "white" }}>
              <Hamburger
                toggled={menuVisible}
                toggle={toggleMenu}
                color={theme.palette.info.main}
                size={24}
              />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>

      {/* MenuBar Component */}
      <MenuBar isActive={menuVisible} />
      {/* Page Title Component */}
      <PageTitle
        iconName={iconName}
        pageType={pageType}
        placeholderText={placeholderText}
        title={titleString}
        onSearchChange={onSearchChange}
        showAddButton={showAddButton}
        showDownloadButton={showDownloadButton}
      />
    </>
  );
}

export default SimplePageHeader;
